import * as React from 'react';
import { SVGProps } from 'react';

const IconRingSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5h-.5a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3H18z" />
  </svg>
);
export default IconRingSizeM;
